














import { Vue, Component, Prop } from 'vue-property-decorator'
import { API, graphqlOperation } from 'aws-amplify'

@Component
export default class FirmwareForm extends Vue {

	@Prop() item
	@Prop() default
	@Prop() create
	@Prop() update
	@Prop() delete

	model: any = null
	creating = false

	submit() {
		if(this.creating) {
			this.runCreate()
		} else {
			this.runUpdate()
		}
	}

	async runCreate() {
		const newItem: any = {}
		Object.keys(this.model).forEach(field => {
			if(this.model[field]) {
				newItem[field] = this.model[field]
			}
		})

		await API.graphql(graphqlOperation(this.create, { input: newItem }))
		this.$emit('end')
	}

	async runUpdate() {
		const changes: any = {}
		Object.keys(this.item).forEach(field => {
			if(this.model[field] !== this.item[field]) {
				changes[field] = this.model[field]
				// dynamodb doeesn't allow empty strings???
				if(changes[field] === '') {
					changes[field] = null
				}
			}
		})
		if(Object.keys(changes).length) {
			if(changes.id !== undefined) {
				// can't change ID in place; run a create (new values) + delete (old ID)
				await Promise.all([this.create(), this.runDelete()])
			} else {
				changes.id = this.model.id
				await API.graphql(graphqlOperation(this.update, { input: changes }))
			}
		}
		this.$emit('end')
	}

	async runDelete() {
		await API.graphql(graphqlOperation(this.delete, { id: this.item.id }))
		this.$emit('end')
	}

	created() {
		if(this.item) {
			this.model = { ...this.item }
			this.creating = false
		} else {
			this.model = { ...this.default }
			this.creating = true
		}
	}

}
